export default function (state, getters, rootState, rootGetters) {
    let filter = getters.filters.filter(i => {
        return i.id === getters.filter;
    })[0];
    if (!filter) return 365;
    switch (filter.dateStep) {
        case 1:
            return 365;
        case 2:
            return 52;
        case 3:
            return 12;
    }
    return 365;
}